// extracted by mini-css-extract-plugin
export default {"wrapper":"N0-z","play":"O0-z"};